import React, { createContext, useContext, useEffect, useState } from 'react';
import { 
  signOut, 
  onAuthStateChanged,
  GoogleAuthProvider,
  OAuthProvider,
  signInWithPopup
} from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from './firebase';
import { updateSasToken } from '../../appConfig';

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [sasTokenLoading, setSasTokenLoading] = useState(false);

  // Function to load SAS token from Firebase
  const loadSasTokenFromFirebase = async () => {
    setSasTokenLoading(true);
    try {
      const configDocRef = doc(db, 'inspectConfig', 'default');
      const configDoc = await getDoc(configDocRef);
      
      if (configDoc.exists()) {
        const configData = configDoc.data();
        const sasToken = configData.APPS_BLOB_SAS_TOKEN || "";
        updateSasToken(sasToken);
        // console.log('SAS Token loaded from Firebase');
      } else {
        console.log('No configuration document found in Firebase');
      }
    } catch (error) {
      console.error('Error loading SAS token from Firebase:', error);
    } finally {
      setSasTokenLoading(false);
    }
  };

  function logout() {
    return signOut(auth);
  }

  function loginWithGoogle() {
    const provider = new GoogleAuthProvider();
    provider.setCustomParameters({
      prompt: 'select_account'  // Forces Google to show account picker
    });
    return signInWithPopup(auth, provider);
  }

  function loginWithMicrosoft() {
    const provider = new OAuthProvider('microsoft.com');
    provider.setCustomParameters({
      prompt: 'select_account'  // Forces Microsoft to show account picker
    });
    return signInWithPopup(auth, provider);
  }

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      setCurrentUser(user);
      
      if (user) {
        // Load SAS token when user is authenticated
        await loadSasTokenFromFirebase();
      }
      
      setLoading(false);
    });

    return unsubscribe;
  }, []);

  const value = {
    currentUser,
    logout,
    loginWithGoogle,
    loginWithMicrosoft,
    loading,
    sasTokenLoading
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
} 